/* eslint no-lone-blocks: 0 */
/* eslint eqeqeq: 0 */
/* eslint no-unused-vars: 0 */
/* eslint array-callback-return: 0 */
/* eslint jsx-a11y/anchor-is-valid: 0 */
import React, {Component} from 'react';
import Tab from 'semantic-ui-react/dist/es/modules/Tab';
import Menu from 'semantic-ui-react/dist/es/collections/Menu';
import Label from 'semantic-ui-react/dist/es/elements/Label';
import Button from 'semantic-ui-react/dist/es/elements/Button';
import Icon from 'semantic-ui-react/dist/es/elements/Icon';
import Confirm from 'semantic-ui-react/dist/es/addons/Confirm';
import MaskedInput from 'react-maskedinput'
import Segment from 'semantic-ui-react/dist/es/elements/Segment';
import Header from 'semantic-ui-react/dist/es/elements/Header';
import NumericInput from 'react-numeric-input';
import NumberFormat from 'react-number-format';

import global from "./global"
import {Form, Dropdown} from 'formsy-semantic-ui-react';
import CKEditor from 'react-ckeditor-wrapper'
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import Loader from 'semantic-ui-react/dist/es/elements/Loader';
import Dimmer from 'semantic-ui-react/dist/es/modules/Dimmer';
import Grid from 'semantic-ui-react/dist/es/collections/Grid';
export class BidListEditRecord extends Component {
    constructor(props) {
        super(props);
        this.state = {
            access_token: this.props.access_token,
            type_of_request: this.props.data.rec.type_of_request,
            type_of_contract: this.props.data.rec.type_of_contract,
            leg_approval: this.props.data.rec.leg_approval,
            estimated_cost: this.props.data.rec.estimated_cost,
            ps_anticipated_source: this.props.data.rec.ps_anticipated_source,
            ps_request_type: this.props.data.rec.ps_request_type,
            ps_payment_type: this.props.data.rec.ps_payment_type,
            ps_mandate_class: this.props.data.rec.ps_mandate_class,
            addl_data: {},
            recid: this.props.data.rec.id,
            data: this.props.data,
            departments: this.props.departments,
            cats: this.props.cats,
            dirtyFlag: this.props.dirtyFlag,
            liaisons: this.props.data.liaisons ,
            confirmOpen: false,
            columns: this.props.columns,
            current_user: JSON.parse(sessionStorage.getItem("current_user")),
            showdimmer: false
        };
    }

    handleSave = () => {

        this.refs.editForm.submit()

    }
    handleCancel = () => {
        this.setState({confirmOpen: false})
    }
    handleUndoConfirm = () => {
        this.setState({confirmOpen: false})
        this.props.loadRecord(this.state.recid)
    }
    undoRecord = () => {
        this.setState({confirmOpen: true})
    }

    notifyError = (errors) => {
        toast.error(errors + "\n(click anywhere to close)", {autoClose: 10000})
    }
    notifySuccess = (msg) => {
        toast.success(msg,{autoClose: 3000})
    }

    getliaisons = (event, {value}) => {
        var component = this
        var parms = {ids: value}
        global.postFetch("common/getliaisons", parms, component.state.access_token).then(function (resp) {
            if (resp.success === "Y") {
                component.setState({
                    liaisons: resp.liaisons
                })
            }
        })
    }

    ChangeRadio = (e, {value, name}) => {
        if (this.state.data.rec.locked) {
            this.notifyError("Contract is locked. No changes allowed.")
            return;
        }
        var addldata = this.state.addl_data
        addldata[name] = value
        var stateObj = {
            addldata: addldata
        }
        stateObj[name] = value
        this.setState(stateObj)
    }

    NumberChange = (a, b, c) => {

        var data = this.state.data
        data.rec[c.name] = a
        var addl_data = this.state.addl_data
        addl_data[c.name] = a
        this.setState({data: data, addl_data: addl_data})

    }
    NumberFieldUpdate = (e) => {
        var addldata = this.state.addl_data
        addldata[e.target.name] = e.target.value
        this.setState({addl_data: addldata})


    }

    formatCommas = (val) => {
        var str = val
        return (str + "").replace(/\b(\d+)((\.\d+)*)\b/g, function (a, b, c) {
            return (b.charAt(0) > 0 && !(c || ".").lastIndexOf(".") ? b.replace(/(\d)(?=(\d{3})+$)/g, "$1,") : b) + c;
        });
    }
    removeCommas = (val) => {
        return parseFloat(val.replace(/,/g, ''));
    }

    onValidSubmit = (formData, resetForm, invalidateForm) => {
        var comp=this
        var data=formData
        this.setState({showdimmer: true})
        var addl_data = this.state.addl_data
        var parms = {...data, ...addl_data}
        
        parms.id=this.state.recid
        parms.bid_status = 'test'
        parms.opening_date = addl_data.contract_start
        if (!this.state.recid) {
            global.postFetch("bids/create", parms, this.state.access_token).then(function (resp) {
                if (resp.success === "Y") {
                    comp.notifySuccess(resp.message)
                    comp.setState({
                        showdimmer: false,
                        recid: resp.data.id
                    })
                } else {
                    comp.setState({
                        showdimmer: false
                    })
                    comp.notifyError(resp.message)
                }
            })
        } else {
            global.postFetch("bids/update", parms, this.state.access_token).then(function (resp) {
                if (resp.success === "Y") {
                    comp.notifySuccess(resp.message)
                    comp.setState({
                        showdimmer: false,
                        recid: resp.data.id
                    })
                } else {
                    comp.setState({
                        showdimmer: false
                    })
                    comp.notifyError(resp.message)
                }
            })
        }
    
    }

    render() {
        const {current_user} = this.state

        const panes = [
            {
                menuItem: 'Request Info',
                pane: (
                    <Tab.Pane key='tab1'>
                        <Form onChange={this.markDirty} ref="editForm" onSubmit={this.onValidSubmit}>
                            <Grid padded={false}>
                                <Grid padded={false} columns='equal'>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Segment raised>
                                                <Header as='h5' content='Sealed Public Bid Information'
                                                                style={{
                                                                    paddingBottom: "0px",
                                                                    textAlign: "center",
                                                                    textDecoration: "underline",
                                                                    fontWeight: "bold"
                                                                }}/>
                                                    <Grid>
                                                        <Grid.Row>
                                                            <Grid.Column width={13}>
                                                                <Form.Input
                                                                    required
                                                                    name="name"
                                                                    label="Project Title/Name"
                                                                    placeholder="Project Title/Name"
                                                                    errorLabel={<Label color="red" pointing/>}
                                                                    defaultValue={this.state.data.rec.name}
                                                                    validationErrors={{
                                                                        isDefaultRequiredValue: 'Project Title/Name is Required',
                                                                    }}/>
                                                            </Grid.Column>
                                                                <Grid.Column width={3}>
                                                                    <Form.Input
                                                                    required
                                                                    name="bid_no"
                                                                    label="RFP/Q No."
                                                                    placeholder="RFP/Q No."
                                                                    errorLabel={<Label color="red" pointing/>}
                                                                    defaultValue={this.state.data.rec.bid_no}
                                                                    validationErrors={{
                                                                        isDefaultRequiredValue: 'RFP/Q No. is Required',
                                                                    }}/>
                                                                </Grid.Column>
                                                            </Grid.Row>
                                                            <Grid.Row>
                                                                <Grid.Column>
                                                                    <Form.TextArea
                                                                        name="description"
                                                                        label="Description"
                                                                        placeholder='Description'
                                                                        defaultValue={this.state.data.rec.description}
                                                                    />
                                                                </Grid.Column>
                                                            </Grid.Row>
                                                            <Grid.Row>
                                                                <Grid.Column>
                                                                    <Segment raised>
                                                                        <Header as='h5' icon='user'
                                                                                content='Department/Liaison Information'
                                                                                style={{paddingBottom: "0px"}}/>

                                                                        <label><b>Department(s)</b>&nbsp;<span
                                                                            style={{color: 'red'}}>*</span></label>
                                                                        <Form.Dropdown
                                                                            fluid
                                                                            selection
                                                                            search={true}
                                                                            multiple={true}
                                                                            options={this.state.data.common.departments}
                                                                            value={this.state.data.rec.contract_depts}
                                                                            placeholder='Select Department'
                                                                            name="department_ids"
                                                                            onChange={this.getliaisons}
                                                                        />
                                                                        <label><b>Liaison(s)</b>&nbsp;<span
                                                                            style={{color: 'red'}}>*</span></label>
                                                                        <Dropdown
                                                                            fluid
                                                                            selection
                                                                            search={true}
                                                                            multiple={true}
                                                                            options={this.state.liaisons}
                                                                            value={this.state.data.rec.contract_lias}
                                                                            placeholder='Select Liaison(s)'
                                                                            name="liaison_ids"
                                                                        />
                                                                        {/* <label><b>Budget Analyst</b>&nbsp;<span
                                                                            style={{color: 'red'}}>*</span></label>
                                                                        <Dropdown
                                                                            fluid
                                                                            selection
                                                                            search={true}
                                                                            multiple={false}
                                                                            options={this.state.liaisons}
                                                                            value={this.state.data.rec.contract_ba}
                                                                            placeholder='Select Budget Analyst'
                                                                            name="budget_analyst_id"
                                                                        /> */}
                                                                    </Segment>
                                                                </Grid.Column>
                                                            </Grid.Row>
                                                            <Grid.Row>
                                                                <Grid.Column width={4}>
                                                                    <Segment raised>
                                                                        <Header as='h5' content='Type of Request'
                                                                            style={{
                                                                                paddingBottom: "0px",
                                                                                textAlign: "center",
                                                                                textDecoration: "underline",
                                                                                fontWeight: "bold"
                                                                            }}/>

                                                                        <Form.Radio
                                                                            label='Sealed Public Bid'
                                                                            name='type_of_request'
                                                                            value='sealed'
                                                                            onChange={this.ChangeRadio}
                                                                            checked={this.state.type_of_request === "sealed"}
                                                                        />
                                                                        <Form.Radio
                                                                            label='Professional Services'
                                                                            name='type_of_request'
                                                                            value='professional'
                                                                            onChange={this.ChangeRadio}
                                                                            checked={this.state.type_of_request === "professional"}
                                                                        />

                                                                    </Segment>
                                                                </Grid.Column>
                                                                <Grid.Column width={4}>
                                                                    <Segment raised>
                                                                        <Header as='h5' content='Legislature Approval Required'
                                                                            style={{
                                                                                paddingBottom: "0px",
                                                                                textAlign: "center",
                                                                                textDecoration: "underline",
                                                                                fontWeight: "bold"
                                                                            }}/>

                                                                        <Form.Radio
                                                                            label='No'
                                                                            name='leg_approval'
                                                                            value='no'
                                                                            onChange={this.ChangeRadio}
                                                                            checked={this.state.leg_approval === "no"}
                                                                        />
                                                                        <Form.Radio
                                                                            label='Yes'
                                                                            name='leg_approval'
                                                                            value='yes'
                                                                            onChange={this.ChangeRadio}
                                                                            checked={this.state.leg_approval === "yes"}
                                                                        />

                                                                    </Segment>
                                                                </Grid.Column>
                                                                
                                                        </Grid.Row>
                                                    </Grid>
                                            </Segment>
                                            </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Segment raised>
                                                <Header as='h5' content='Sealed Public Bid Information'
                                                                style={{
                                                                    paddingBottom: "0px",
                                                                    textAlign: "center",
                                                                    textDecoration: "underline",
                                                                    fontWeight: "bold"
                                                                }}/>
                                            <Grid padded={false}>
                                                <Grid.Row>
                                                    <Grid.Column width={4}>
                                                        <Segment raised>
                                                            <Header as='h5' content='Type of Contract'
                                                                style={{
                                                                    paddingBottom: "0px",
                                                                    textAlign: "center",
                                                                    textDecoration: "underline",
                                                                    fontWeight: "bold"
                                                                }}/>

                                                            <Form.Radio
                                                                label='Construction/Public Works'
                                                                name='type_of_contract'
                                                                value='con'
                                                                onChange={this.ChangeRadio}
                                                                checked={this.state.type_of_contract === "con"}
                                                            />
                                                            <Form.Radio
                                                                label='One Time Buy'
                                                                name='type_of_contract'
                                                                value='one'
                                                                onChange={this.ChangeRadio}
                                                                checked={this.state.type_of_contract === "one"}
                                                            />
                                                            <Form.Radio
                                                                label='Term Contract'
                                                                name='type_of_contract'
                                                                value='term'
                                                                onChange={this.ChangeRadio}
                                                                checked={this.state.type_of_contract === "term"}
                                                            />

                                                        </Segment>
                                                    </Grid.Column>
                                                    <Grid.Column width={4}>
                                                        <Segment raised>
                                                            <Header as='h5' content='Estimated Project Cost'
                                                                style={{
                                                                    paddingBottom: "0px",
                                                                    textAlign: "center",
                                                                    textDecoration: "underline",
                                                                    fontWeight: "bold"
                                                                }}/>

                                                            <Form.Radio
                                                                label='Less than $1 million'
                                                                name='estimated_cost'
                                                                value='1'
                                                                onChange={this.ChangeRadio}
                                                                checked={this.state.estimated_cost === "1"}
                                                            />
                                                            <Form.Radio
                                                                label='$1 million - $3 million'
                                                                name='estimated_cost'
                                                                value='2'
                                                                onChange={this.ChangeRadio}
                                                                checked={this.state.estimated_cost === "2"}
                                                            />
                                                            <Form.Radio
                                                                label='> $3 million'
                                                                name='estimated_cost'
                                                                value='3'
                                                                onChange={this.ChangeRadio}
                                                                checked={this.state.estimated_cost === "3"}
                                                            />

                                                        </Segment>
                                                    </Grid.Column>
                                                </Grid.Row>
                                            </Grid>
                                            </Segment>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Segment raised>
                                                <Header as='h5' content='Professional Services Bid Information'
                                                                style={{
                                                                    paddingBottom: "0px",
                                                                    textAlign: "center",
                                                                    textDecoration: "underline",
                                                                    fontWeight: "bold"
                                                                }}/>
                                            <Grid padded={false}>
                                                <Grid.Row>
                                                    <Grid.Column width={4}>
                                                        <Segment raised>
                                                            <Header as='h5' content='Anticipated Source'
                                                                style={{
                                                                    paddingBottom: "0px",
                                                                    textAlign: "center",
                                                                    textDecoration: "underline",
                                                                    fontWeight: "bold"
                                                                }}/>

                                                            <Form.Radio
                                                                label='Single Vendor'
                                                                name='ps_anticipated_source'
                                                                value='single'
                                                                onChange={this.ChangeRadio}
                                                                checked={this.state.ps_anticipated_source === "single"}
                                                            />
                                                            <Form.Radio
                                                                label='Multiple Vendors'
                                                                name='ps_anticipated_source'
                                                                value='multi'
                                                                onChange={this.ChangeRadio}
                                                                checked={this.state.ps_anticipated_source === "multi"}
                                                            />

                                                        </Segment>
                                                    </Grid.Column>
                                                    <Grid.Column width={4}>
                                                        <Segment raised>
                                                            <Header as='h5' content='Request Type'
                                                                style={{
                                                                    paddingBottom: "0px",
                                                                    textAlign: "center",
                                                                    textDecoration: "underline",
                                                                    fontWeight: "bold"
                                                                }}/>

                                                            <Form.Radio
                                                                label='RFP'
                                                                name='ps_request_type'
                                                                value='rfp'
                                                                onChange={this.ChangeRadio}
                                                                checked={this.state.ps_request_type === "rfp"}
                                                            />
                                                            <Form.Radio
                                                                label='RFQ'
                                                                name='ps_request_type'
                                                                value='rfq'
                                                                onChange={this.ChangeRadio}
                                                                checked={this.state.ps_request_type === "rfq"}
                                                            />
                                                            <Form.Radio
                                                                label='Other'
                                                                name='ps_request_type'
                                                                value='Other'
                                                                onChange={this.ChangeRadio}
                                                                checked={this.state.ps_request_type === "Other"}
                                                            />

                                                        </Segment>
                                                    </Grid.Column>
                                                    <Grid.Column width={4}>
                                                        <Segment raised>
                                                            <Header as='h5' content='Payment Type'
                                                                style={{
                                                                    paddingBottom: "0px",
                                                                    textAlign: "center",
                                                                    textDecoration: "underline",
                                                                    fontWeight: "bold"
                                                                }}/>

                                                            <Form.Radio
                                                                label='Fee for Service'
                                                                name='ps_payment_type'
                                                                value='fee'
                                                                onChange={this.ChangeRadio}
                                                                checked={this.state.ps_payment_type === "fee"}
                                                            />
                                                            <Form.Radio
                                                                label='Pay for Performance'
                                                                name='ps_payment_type'
                                                                value='performance'
                                                                onChange={this.ChangeRadio}
                                                                checked={this.state.ps_payment_type === "performance"}
                                                            />
                                                            <Form.Radio
                                                                label='Program Funded'
                                                                name='ps_payment_type'
                                                                value='program'
                                                                onChange={this.ChangeRadio}
                                                                checked={this.state.ps_payment_type === "program"}
                                                            />

                                                        </Segment>
                                                    </Grid.Column>
                                                    <Grid.Column width={4}>
                                                        <Segment raised>
                                                            <Header as='h5' content='Mandate Classification'
                                                                style={{
                                                                    paddingBottom: "0px",
                                                                    textAlign: "center",
                                                                    textDecoration: "underline",
                                                                    fontWeight: "bold"
                                                                }}/>

                                                            <Form.Radio
                                                                label='Non-Mandated'
                                                                name='ps_mandate_class'
                                                                value='N'
                                                                onChange={this.ChangeRadio}
                                                                checked={this.state.ps_mandate_class === "N"}
                                                            />
                                                            <Form.Radio
                                                                label='Hard Mandate'
                                                                name='ps_mandate_class'
                                                                value='H'
                                                                onChange={this.ChangeRadio}
                                                                checked={this.state.ps_mandate_class === "H"}
                                                            />
                                                            <Form.Radio
                                                                label='Soft Mandate'
                                                                name='ps_mandate_class'
                                                                value='S'
                                                                onChange={this.ChangeRadio}
                                                                checked={this.state.ps_mandate_class === "S"}
                                                            />
                                                            <Form.Radio
                                                                label='Federal/State Initiative'
                                                                name='ps_mandate_class'
                                                                value='F'
                                                                onChange={this.ChangeRadio}
                                                                checked={this.state.ps_mandate_class === "F"}
                                                            />

                                                        </Segment>
                                                    </Grid.Column>
                                                </Grid.Row>
                                                <Grid.Row>
                                                    <Grid.Column width={4}>
                                                        <Segment raised>
                                                            <Header as='h5' content='Funding Sources'
                                                                    style={{
                                                                        paddingBottom: "0px",
                                                                        textAlign: "center",
                                                                        textDecoration: "underline",
                                                                        fontWeight: "bold"
                                                                    }}/>
                                                            <Grid padded={false} columns='equal'>
                                                                <Grid.Row style={{
                                                                    paddingBottom: "0px",
                                                                    paddingTop: "5px"
                                                                }}>
                                                                    <Grid.Column size={2}
                                                                                    style={{textAlign: "right"}}>
                                                                        Federal %

                                                                    </Grid.Column>
                                                                    <Grid.Column width={8}>
                                                                        <NumericInput
                                                                            value={this.state.data.rec.percent_federal}
                                                                            min={0}
                                                                            max={100}
                                                                            precision={2}
                                                                            strict
                                                                            onChange={this.NumberChange}
                                                                            name="percent_federal"
                                                                            format={this.formatCommas}
                                                                            parse={this.removeCommas}


                                                                        /><br/>

                                                                    </Grid.Column>


                                                                </Grid.Row>
                                                                <Grid.Row style={{
                                                                    paddingBottom: "0px",
                                                                    paddingTop: "5px"
                                                                }}>
                                                                    <Grid.Column size={2}
                                                                                    style={{textAlign: "right"}}>
                                                                        State %

                                                                    </Grid.Column>
                                                                    <Grid.Column width={8}>
                                                                        <NumericInput
                                                                            value={this.state.data.rec.percent_state}
                                                                            min={0}
                                                                            max={100}
                                                                            precision={2}
                                                                            strict
                                                                            onChange={this.NumberChange}
                                                                            name="percent_state"
                                                                            format={this.formatCommas}
                                                                            parse={this.removeCommas}


                                                                        /><br/>

                                                                    </Grid.Column>


                                                                </Grid.Row>
                                                                <Grid.Row style={{
                                                                    paddingBottom: "0px",
                                                                    paddingTop: "5px"
                                                                }}>
                                                                    <Grid.Column size={2}
                                                                                    style={{textAlign: "right"}}>
                                                                        County %

                                                                    </Grid.Column>
                                                                    <Grid.Column width={8}>
                                                                        <NumericInput
                                                                            value={this.state.data.rec.percent_county}
                                                                            min={0}
                                                                            max={100}
                                                                            precision={2}
                                                                            strict
                                                                            onChange={this.NumberChange}
                                                                            name="percent_county"
                                                                            format={this.formatCommas}
                                                                            parse={this.removeCommas}


                                                                        /><br/>

                                                                    </Grid.Column>


                                                                </Grid.Row>
                                                                <Grid.Row style={{
                                                                    paddingBottom: "0px",
                                                                    paddingTop: "5px"
                                                                }}>
                                                                    <Grid.Column size={2}
                                                                                    style={{textAlign: "right"}}>
                                                                        Local %

                                                                    </Grid.Column>
                                                                    <Grid.Column width={8}>
                                                                        <NumericInput
                                                                            value={this.state.data.rec.percent_local}
                                                                            min={0}
                                                                            max={100}
                                                                            precision={2}
                                                                            strict
                                                                            onChange={this.NumberChange}
                                                                            name="percent_local"
                                                                            format={this.formatCommas}
                                                                            parse={this.removeCommas}


                                                                        /><br/>

                                                                    </Grid.Column>


                                                                </Grid.Row>
                                                                <Grid.Row style={{
                                                                    paddingBottom: "5px",
                                                                    paddingTop: "5px"
                                                                }}>
                                                                    <Grid.Column size={2}
                                                                                    style={{textAlign: "right"}}>
                                                                        Other %

                                                                    </Grid.Column>
                                                                    <Grid.Column width={8}>
                                                                        <NumericInput
                                                                            value={this.state.data.rec.percent_other}
                                                                            min={0}
                                                                            max={100}
                                                                            precision={2}
                                                                            strict
                                                                            onChange={this.NumberChange}
                                                                            name="percent_other"
                                                                            format={this.formatCommas}
                                                                            parse={this.removeCommas}


                                                                        /><br/>

                                                                    </Grid.Column>


                                                                </Grid.Row>
                                                            </Grid>
                                                                            
                                                        </Segment>
                                                    </Grid.Column>
                                                    <Grid.Column width={8}>
                                                        <Segment raised>
                                                            <Header as='h5' content='RFP Info'
                                                                    style={{
                                                                        paddingBottom: "0px",
                                                                        textAlign: "center",
                                                                        textDecoration: "underline",
                                                                        fontWeight: "bold"
                                                                    }}/>
                                                            <Grid padded={false} columns='equal'>
                                                                <Grid.Row style={{
                                                                    paddingBottom: "0px",
                                                                    paddingTop: "5px"
                                                                }}>
                                                                    <Grid.Column width={16}>
                                                                        <label><b>Anticipated RFP Date</b>&nbsp;<span
                                                                        style={{color: 'red'}}>*</span></label>
                                                                        <MaskedInput name="ps_anticipated_rfp_date"
                                                                                        onChange={this.NumberFieldUpdate}
                                                                                        value={this.state.data.rec.ps_anticipated_rfp_date}
                                                                                        mask="##/##/####"
                                                                        />
                                                                    </Grid.Column>


                                                                </Grid.Row>
                                                                <Grid.Row style={{
                                                                    paddingBottom: "5px",
                                                                    paddingTop: "5px"
                                                                }}>
                                                                    <Grid.Column width={16}>
                                                                        <Form.TextArea
                                                                            name="ps_rfp_waive"
                                                                            label="Justification for Waiving RFP"
                                                                            placeholder='Justification for Waiving RFP'
                                                                            defaultValue={this.state.data.rec.ps_rfp_waive}
                                                                        />
                                                                    </Grid.Column>
                                                                </Grid.Row>

                                                            </Grid>

                                                        </Segment>
                                                    </Grid.Column>

                                                    <Grid.Column width={4}>
                                                        <Segment raised>
                                                            <Header as='h5' content='Contract Info'
                                                                    style={{
                                                                        paddingBottom: "0px",
                                                                        textAlign: "center",
                                                                        textDecoration: "underline",
                                                                        fontWeight: "bold"
                                                                    }}/>
                                                            <Grid padded={false} columns='equal'>
                                                                <Grid.Row style={{
                                                                    paddingBottom: "0px",
                                                                    paddingTop: "5px"
                                                                }}>
                                                                    <Grid.Column width={16}>
                                                                        <label><b>Contract Start Date</b>&nbsp;<span
                                                                        style={{color: 'red'}}>*</span></label>
                                                                        <MaskedInput name="contract_start"
                                                                                        onChange={this.NumberFieldUpdate}
                                                                                        value={this.state.data.rec.contract_start}
                                                                                        mask="##/##/####"
                                                                        />
                                                                    </Grid.Column>


                                                                </Grid.Row>
                                                                <Grid.Row style={{
                                                                    paddingBottom: "0px",
                                                                    paddingTop: "5px"
                                                                }}>
                                                                    <Grid.Column width={16}>
                                                                        <label><b>Contract End Date</b>&nbsp;<span
                                                                        style={{color: 'red'}}>*</span></label>
                                                                        <MaskedInput name="contract_end"
                                                                                        onChange={this.NumberFieldUpdate}
                                                                                        value={this.state.data.rec.contract_end}
                                                                                        mask="##/##/####"
                                                                        />
                                                                    </Grid.Column>


                                                                </Grid.Row>

                                                            </Grid>

                                                        </Segment>
                                                    </Grid.Column>

                                                </Grid.Row>
                                                
                                            </Grid>
                                            </Segment>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Grid>
                        </Form>
                    </Tab.Pane>
                )
            }//, 
            // {
            //     menuItem: 'Web Plublishing info',
            //     pane: (
            //         <Tab.Pane key='tab1'>
            //             <Form onChange={this.markDirty} ref="editForm" onSubmit={this.onValidSubmit}>
            //                 <Grid>
            //                     <Grid.Row>
            //                         <Grid.Column width={8}>
            //                             <label><b>Publish Date</b>&nbsp;<span
            //                             style={{color: 'red'}}>*</span></label>
            //                             <MaskedInput name="contract_start"
            //                                             onChange={this.NumberFieldUpdate}
            //                                             //value={this.state.data.rec.contract_start}
            //                                             mask="##/##/####"
            //                             />
            //                         </Grid.Column>
            //                         <Grid.Column width={8}>
            //                             <label><b>Unpublish Date</b>&nbsp;<span
            //                             style={{color: 'red'}}>*</span></label>
            //                             <MaskedInput name="contract_end"
            //                                             onChange={this.NumberFieldUpdate}
            //                                             //value={this.state.data.rec.contract_end}
            //                                             mask="##/##/####"
            //                             />
            //                         </Grid.Column>
            //                     </Grid.Row>
            //                 </Grid>
                            
            //             </Form>
            //         </Tab.Pane>
            //     )
            // }
        ]
        return (
            <div>
                <Dimmer active={this.state.showdimmer}>
                    <Loader size='small' active={this.state.showdimmer}>Working.....</Loader></Dimmer>

                <Confirm
                    open={this.state.confirmOpen}
                    onCancel={this.handleCancel}
                    onConfirm={this.handleUndoConfirm}
                    content="Are you sure you want to undo changes?"
                    style={{fontSize: "1.2rem"}}

                />
                <Menu>
                <Menu.Item>
                    <Button  size="tiny" color="green" onClick={this.handleSave}>
                        <Icon name='save'/> Save
                    </Button>
                </Menu.Item>

            </Menu>
                <br/>
                    <Tab renderActiveOnly={false} panes={panes} />
            </div>

        );
    }

}